import filePropsSetter from '../factories/filePropsSetter'
import { unset, set } from 'cerebral/operators'
import { state } from 'cerebral/tags'
import inDeleteMediaView from '../actions/inDeleteMediaView'
import setSelectedFiles from '../actions/setSelectedFiles'

export default [
  inDeleteMediaView,
  {
    true: [
      unset(state`media.currentFile`),
      set(state`media.tags.showShared`, false),
      filePropsSetter('media.files', { prop: 'selected', value: false }),
      setSelectedFiles
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/deselectAllFiles.js